<template>
  <div class="ly_modal_container" :style="{width: '840px', zIndex}">
    <div class="ly_modal_header" @mousedown="dragStart">
      <h1 v-if="detailData" class="title">소식톡톡 반복/맞춤소식 상세</h1>
    </div>
    <div class="ly_modal_content" style="min-height:280px">
      <template v-if="detailData" class="table_wrapper">
        <table class="table_view">
          <caption>
            <span class="blind">소식톡톡 반복/맞춤소식 상세</span>
          </caption>
          <colgroup>
            <col width="15%" />
            <col />
            <col width="15%" />
            <col />
          </colgroup>
          <tbody class="table_view_body">
            <tr>
              <th>소식종류</th>
              <!-- <td colspan="3">{{detailData.newsType}}</td> -->
              <RepeatTypeTextColumn
                colspan="3"
                :singleLine="true"
                :newsType="detailData.newsType"
                :customNewsType="detailData.customNewsType"
              />
            </tr>
            <tr>
              <th>받는사람</th>
              <td>{{detailData.rcpDesc}}</td>
              <th>작성자</th>
              <td>{{detailData.userName}}</td>
            </tr>
            <tr>
              <th>유효기간</th>
              <PeriodColumn :start="detailData.validFrom" :end="detailData.validTo" />
              <th>전송시간</th>
              <RepeatStrategyColumn :value="detailData.repeatStrategy" styles="type_ib">
                {{detailData.reserveTime.slice(0,5)}}
                <div
                  v-if="detailData.hasSnooze"
                >(미확인 알림 {{detailData.snoozeMax}}회 : {{detailData.snoozeInterval}}시간 간격)</div>
              </RepeatStrategyColumn>
            </tr>
            <tr>
              <td colspan="4">
                <div class="view" v-html="$utils.nl2br(detailData.boardContent)"></div>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="btn_area">
          <button type="button" class="btn_default" @click="close">닫기</button>
        </div>
      </template>
    </div>

    <button type="button" @click.prevent="close" class="ly_modal_close">
      <span class="ico">팝업 닫기</span>
    </button>
  </div>
</template>

<script>
import newsMixin from "$views/News/_mixin";
import popupMixin from "$mixins/popup";

export default {
  mixins: [newsMixin, popupMixin],
  props: {
    newsId: [String, Number]
  },
  data() {
    return {
      detailData: null
    };
  },
  mounted() {
    this.$axios
      .get(`/admin/v2/news/repeat/${this.newsId}/detail`)
      .then(({ data }) => {
        this.detailData = data.data;
        this.$nextTick(this.moveToCenter);
      });
  }
};
</script>
